import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';

@Component({
  selector: 'gob-univers',
  templateUrl: './univers.component.html',
  styleUrls: ['./univers.component.scss']
})
export class UniversComponent implements OnInit, AfterViewInit {

  @ViewChildren('animBlock') animBlocks: QueryList<ElementRef>;

  titreTexte: string = 'DECOUVREZ NOTRE UNIVERS';
  mots: string[][] = [];

  // Données des sections
  sections = [
    {
      titre: "Le repaire des passionnés",
      sousTitre: "Plus qu'une boutique, un lieu de vie",
      desc: "La Caverne du Gobelin n'est pas seulement un magasin de jeux. C'est un sanctuaire pour tous ceux qui cherchent à s'évader. Du jeu de plateau stratégique aux cartes à collectionner (Magic, Yu Gi Oh, Pokemon...), en passant par le jeu de rôle immersif et les figurines minutieuses, nous sélectionnons le meilleur de l'univers ludique pour vous.",
      images: [
        'assets/img/boutiques/Semecourt/P1129504.jpg',
        'assets/img/boutiques/Nancy/P1129693.jpg',
        'assets/img/boutiques/Metz/P1129614.jpg', 
        'assets/img/boutiques/PaM/P1129727.jpg',
        'assets/img/boutiques/Thionville/P1129564.jpg',
        'assets/img/boutiques/Toul/P1129705.jpg'
      ],
      currentIndex: 0,
      reverse: false,
      boutons: [
        { label: 'Explorer le catalogue', lien: '/products/categ/68394191c6f7a/tous-nos-jeux-de-societe', fragment: null }
      ]
    },
    {
      titre: "L'animation au cœur du Jeu",
      sousTitre: "Jouer, partager, rencontrer",
      desc: "Le jeu ne vit que s'il est partagé. C'est pourquoi nous organisons quotidiennement des animations : tournois de cartes endiablés, soirées découvertes, ateliers peinture sur figurines ou initiations au jeu de rôle. Nos espaces sont conçus pour que vous puissiez vous asseoir et lancer les dés immédiatement.",
      images: [
        'assets/img/boutiques/Nancy/P1129657.jpg',
        'assets/img/boutiques/Metz/P1129621.jpg',
        'assets/img/boutiques/Semecourt/P1129551.jpg',
        'assets/img/boutiques/Thionville/P1129592.jpg'
      ],
      currentIndex: 0,
      reverse: true,
      boutons: [
        { label: 'Voir nos animations', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes', fragment: 'animations' } // Lien à adapter selon tes vraies routes
      ]
    },
    {
      titre: "Nos Gobelins vous conseillent",
      sousTitre: "Des conseils de joueurs pour des joueurs",
      desc: "Chez nous, pas de robots ni de discours formatés. Nos conseillers sont avant tout des joueurs passionnés qui testent, approuvent (ou débattent !) chaque nouveauté. Que vous cherchiez un petit jeu d'apéro ou une campagne complexe de 50 heures, ils sauront trouver la boîte qui correspond exactement à vos envies.",
      images: [
        'assets/img/boutiques/Thionville/P1129589.jpg',
        'assets/img/boutiques/Toul/P1129716.jpg',
        'assets/img/boutiques/Semecourt/P1129539.jpg',
      ],
      currentIndex: 0,
      reverse: false,
      boutons: [] 
    },
    {
      titre: "Au-delà des murs",
      sousTitre: "Festivals & Communauté",
      desc: "Notre passion déborde de nos boutiques. Nous sommes les artisans d'événements majeurs comme les Jeux du Stan, les Jeux du Graoully et les Jeux du Roc. C'est aussi cette expertise qui nous permet d'organiser les Gold'n Gob, notre prix ludique unique où c'est VOUS, le public, qui élisez les meilleurs jeux de l'année.",
      images: [
        'assets/img/univers/trophee_goldNgob.png' 
      ],
      currentIndex: 0,
      reverse: true, 
      boutons: [
        { label: 'Découvrir les Gold\'n Gob', lien: '/goldn-gob', fragment: null },
      ]
    }
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private location: Location) { }

  isExternalLink(url: string): boolean {
    return url.startsWith('http');
  }

  goBack(): void {
    this.location.back();
  }
  ngOnInit(): void {
    const motsBruts = this.titreTexte.split(' ');
    this.mots = motsBruts.map(mot => mot.split(''));
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });

        if (this.animBlocks) {
          this.animBlocks.forEach(block => {
            const rect = block.nativeElement.getBoundingClientRect();
            if (rect.top < window.innerHeight) {
               block.nativeElement.classList.add('visible');
            } else {
               observer.observe(block.nativeElement);
            }
          });
        }
      }, 100); 
    }
  }

  prevImage(section: any) {
    if (section.images.length > 1) {
      if (section.currentIndex > 0) {
        section.currentIndex--;
      } else {
        section.currentIndex = section.images.length - 1;
      }
    }
  }

  nextImage(section: any) {
    if (section.images.length > 1) {
      if (section.currentIndex < section.images.length - 1) {
        section.currentIndex++;
      } else {
        section.currentIndex = 0;
      }
    }
  }
}